module.exports = __webpack_public_path__ + "static/img/gawb.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gawb.png
// module id = bsgX
// module chunks = 2